import { action, makeObservable, observable } from 'mobx';

export class LayoutStore {
    constructor() {
        makeObservable(this, {
            sidebarCollapsed: observable,
            toggleSidebar: action,
        });
    }

    public sidebarCollapsed = false;

    public readonly toggleSidebar = (status = !this.sidebarCollapsed) => {
        this.sidebarCollapsed = status;
    };
}